import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserInfoService } from './services/user-info.service';
import { ProfileResolverService } from './resolvers/profile.resolver';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [],
  declarations: [],
  providers: [
    UserInfoService,
    ProfileResolverService
  ]
})
export class CoreModule {
}
